<template>
  <div class="bar" :id="id"></div>
</template>

<script type="text/ecmascript-6">
import Bar from './Bar.js'
export default Bar
</script>

<style lang="scss">
@import "Bar.scss";
</style>



// WEBPACK FOOTER //
// src/components/echarts/bar/Bar.vue